import { DS_DIRECTION, type DSDirection } from "@/src/design_system/shared/types/direction";
import { DS_TABS_VARIANT, type DSTabsVariant } from "../types/props";

export const DS_TABS_CLASSES = {
  Root: "ds-tabs",
  ListWrapper: "ds-tabs__list-wrapper",
  List: "ds-tabs__list",
  Item: "ds-tabs__item",
  ItemContent: "ds-tabs__item-content",
  Icon: "ds-tabs__icon",
  Text: "ds-tabs__text",
  Badge: "ds-tabs__badge",
  BadgeFloating: "ds-tabs__badge--floating",
  Suffix: "ds-tabs__suffix",
  DirectionHorizontal: "ds-tabs--horizontal",
  DirectionVertical: "ds-tabs--vertical",
  VariantDefault: "ds-tabs--default",
  VariantOnlyTexts: "ds-tabs--only-texts",
  VariantOnlyIcons: "ds-tabs--only-icons",
  ItemActive: "ds-tabs__item--active",
  ItemDisabled: "ds-tabs__item--disabled",
} as const;

export const DS_TABS_DIRECTION_TO_CLASS_MAP: Record<DSDirection, string> = {
  [DS_DIRECTION.Horizontally]: DS_TABS_CLASSES.DirectionHorizontal,
  [DS_DIRECTION.Vertically]: DS_TABS_CLASSES.DirectionVertical,
} as const;

export const DS_TABS_VARIANT_TO_CLASS_MAP: Record<DSTabsVariant, string> = {
  [DS_TABS_VARIANT.Default]: DS_TABS_CLASSES.VariantDefault,
  [DS_TABS_VARIANT.OnlyTexts]: DS_TABS_CLASSES.VariantOnlyTexts,
  [DS_TABS_VARIANT.OnlyIcons]: DS_TABS_CLASSES.VariantOnlyIcons,
} as const;
